import { component } from "picoapp";

export default component((node, ctx) => {
  const login = node.querySelector(".account-auth-login");
  const recover = node.querySelector(".account-auth-recover-password");

  /* eslint-disable */
  const recoverIsTarget = window.location.hash.match(/\#recover/)
    ? true
    : false;
  /* eslint-enable */
  const successMessage = node.querySelector(".js-recover-success") !== null;

  if (recoverIsTarget || successMessage) {
    login.style.display = "none";
    recover.style.display = "block";
  } else {
    login.style.display = "block";
  }
});
